import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonIcon } from '../../../types/FormModelTypes';
const SecondaryButton = ({ text, onClickFn, testId, enabled, submitButton = false, icon }) => {
    const { t } = useTranslation();
    return (_jsxs("button", Object.assign({ "data-testid": testId, className: "outline-btn", onClick: onClickFn, disabled: !enabled, type: submitButton ? 'submit' : 'button' }, { children: [t(text), icon && icon === ButtonIcon.ARROW && _jsx("i", { className: "bi bi-arrow-right" })] })));
};
export default SecondaryButton;
